/**
 * Спеки компонентов UI kit.
 *
 * Правило: в TSX и CSS компонентов нет ни одного «сырого» значения — только
 * локальные CSS-переменные, которые заполняются из спеки. Спека, в свою очередь,
 * ссылается исключительно на токены из design-tokens.json.
 *
 * Поменялся UI kit -> правим design-tokens.json и спеки, компоненты не трогаем.
 */

/** Набор CSS-переменных компонента. */
export type StyleVars = Record<string, string>;

/** Имя типографического стиля из design-tokens.json (`typography`). */
export type TypographyName =
  | "caption-11-medium"
  | "caption-12-medium"
  | "caption-12-semibold"
  | "caption-13-medium"
  | "text-14-medium"
  | "text-14-semibold"
  | "header-16-semibold"
  | "header-20-semibold"
  | "header-24-semibold"
  | "header-30-semibold"
  | "mono-11"
  | "mono-12";

export const typographyClass = (name: TypographyName): string => `typo-${name}`;

/** Токен -> ссылка на CSS-переменную. */
export const token = (path: string): string => `var(--${path})`;

export const color = (path: string): string => token(`color-${path}`);
export const spacing = (step: string): string => token(`spacing-${step}`);
export const radius = (name: string): string => token(`radius-${name}`);
export const size = (name: string): string => token(`size-${name}`);
export const borderWidth = (name: string): string => token(`border-width-${name}`);
export const shadow = (name: string): string => token(`shadow-${name}`);
export const duration = (name: string): string => token(`duration-${name}`);
export const fontFamily = (name: string): string => token(`font-family-${name}`);

export const TRANSPARENT = "transparent";

/** Слить несколько наборов переменных в один объект стиля. */
export const mergeVars = (...groups: (StyleVars | undefined)[]): StyleVars =>
  Object.assign({}, ...groups.filter(Boolean));
